import api from './client';
import type {
  FbFieldDef, FbAccountListItem, FbAccountSecret, CredentialRevealPending,
  CreateFbFieldInput, UpdateFbFieldInput, CreateFbAccountInput, UpdateFbAccountInput,
} from './types';

export async function listFbFields(): Promise<FbFieldDef[]> {
  return api.get<FbFieldDef[]>('/admin/facebook/fields');
}
export async function createFbField(data: CreateFbFieldInput): Promise<{ id: string }> {
  return api.post<{ id: string }>('/admin/facebook/fields', data);
}
export async function updateFbField(id: string, data: UpdateFbFieldInput): Promise<{ id: string }> {
  return api.patch<{ id: string }>(`/admin/facebook/fields/${id}`, data);
}
export async function deleteFbField(id: string): Promise<{ message: string }> {
  return api.delete<{ message: string }>(`/admin/facebook/fields/${id}`);
}

export async function listFbAccounts(): Promise<FbAccountListItem[]> {
  return api.get<FbAccountListItem[]>('/admin/facebook/accounts');
}
export async function createFbAccount(data: CreateFbAccountInput): Promise<{ id: string }> {
  return api.post<{ id: string }>('/admin/facebook/accounts', data);
}
export async function updateFbAccount(id: string, data: UpdateFbAccountInput): Promise<{ id: string }> {
  return api.patch<{ id: string }>(`/admin/facebook/accounts/${id}`, data);
}
export async function deleteFbAccount(id: string): Promise<{ message: string }> {
  return api.delete<{ message: string }>(`/admin/facebook/accounts/${id}`);
}
/**
 * Answers either with the fields or — for anyone but a super admin without a
 * live approval — with a filed request. Both arrive as 2xx, so the caller has
 * to look at `pending_approval` rather than at the HTTP status.
 */
export async function revealFbAccount(
  id: string,
): Promise<FbAccountSecret | CredentialRevealPending> {
  return api.post<FbAccountSecret | CredentialRevealPending>(
    `/admin/facebook/accounts/${id}/reveal`, {},
  );
}
